import * as Sentry from '@sentry/browser';

const sentryDSN = process.env.REACT_APP_SENTRY_DSN;

export const init = () => {
  Sentry.init({ dsn: sentryDSN });
};
